export const RETURNING_CUSTOMER_COOKIE_KEY = 'returningCustomer';
export const RETURNING_CUSTOMER_URL_QUERY = 'returningCustomerCL';
